import Tenant from '@/services/tenant'

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Tenant.fetch().then((response) => {
      commit('SET_LIST', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetch
}



// WEBPACK FOOTER //
// ./src/features/tenant_representatives/store/actions.js